import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type SiteChromeContextValue = {
  hideSiteChrome: boolean;
  setLotDetailOpen: (open: boolean) => void;
};

const SiteChromeContext = createContext<SiteChromeContextValue>({
  hideSiteChrome: false,
  setLotDetailOpen: () => {},
});

export const SiteChromeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lotDetailOpen, setLotDetailOpen] = useState(false);

  const setLotDetailOpenStable = useCallback((open: boolean) => {
    setLotDetailOpen(open);
  }, []);

  const value = useMemo(
    () => ({
      hideSiteChrome: lotDetailOpen,
      setLotDetailOpen: setLotDetailOpenStable,
    }),
    [lotDetailOpen, setLotDetailOpenStable]
  );

  return <SiteChromeContext.Provider value={value}>{children}</SiteChromeContext.Provider>;
};

export function useSiteChrome(): SiteChromeContextValue {
  return useContext(SiteChromeContext);
}
